import {gql} from 'apollo-angular';
import {ImageFragment} from "./fragments/Image";

export const GET_ROOKIE_DAY_PROVIDER_LOGOS = gql`
  query GetRookieDayProviderLogos($districtId: Int!) {
    rookiedayProvidersByDistrict(districtId: $districtId) {
      id
      name
      companyProfilePicture {
        id
        name
        image {
          ...imageFields
        }
      }
    }
  }
  ${ImageFragment}
`;
